import React, { useEffect, useState } from "react";

// Helper to get query params
function useQuery() {
  return new URLSearchParams(window.location.search);
}

export default function ConnectWithLawyer() {
  const query = useQuery();
  const clientId = query.get("clientId");
  const token = localStorage.getItem("token");

  const [lawyers, setLawyers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState([]);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    lawyer_id: "",
    title: "",
    message: "",
  });
  const [success, setSuccess] = useState("");
  const [formError, setFormError] = useState("");

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    const fetchLawyers = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/lawyers`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const data = await res.json();
        if (res.ok) {
          setLawyers(data.lawyers || []);
        } else {
          setError(data.message || "Failed to load lawyers.");
        }
      } catch {
        setError("Network error.");
      }
      setLoading(false);
    };
    fetchLawyers();
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
  const handleFileChange = (e) => {
    setDocuments([...e.target.files]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");
    setSuccess("");
    if (!form.lawyer_id || !form.title) {
      setFormError("Please select a lawyer and enter a title.");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("lawyer_id", form.lawyer_id);
      formData.append("title", form.title);
      formData.append("message", form.message);
      formData.append("client_id", clientId);
      documents.forEach((file) => {
        formData.append("documents[]", file);
      });
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/client/request-lawyer`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          // Do NOT set Content-Type for FormData
        },
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess("Request sent successfully!");
        setForm({ lawyer_id: "", title: "", message: "" });
        setDocuments([]);
      } else {
        setFormError(data.message || "Failed to send request.");
      }
    } catch {
      setFormError("Network error.");
    }
  };

  const handleLogin = () => {
    window.location.href = "/login";
  };

  return (
    <div className="bg-gray-50 min-h-screen py-8 px-4">
      <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-900 p-4 mb-6 max-w-3xl mx-auto rounded">
        <strong>Latest Legal News:</strong> Supreme Court clarifies property rights in joint family cases. Stay updated for more legal news!
      </div>
      <h2 className="text-2xl sm:text-3xl font-bold text-blue-900 mb-6 text-center">
        Connect With Lawyer
      </h2>
      {!token ? (
        <div className="text-center mt-10">
          <div className="text-lg text-red-700 mb-4">
            You need to login to raise a request to a lawyer.
          </div>
          <button
            className="bg-blue-700 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-800 transition-colors duration-200"
            onClick={handleLogin}
          >
            Login
          </button>
        </div>
      ) : (
        <div className="max-w-md mx-auto bg-white rounded-xl shadow-md p-6">
          {loading && <div className="text-center">Loading lawyers...</div>}
          {error && <div className="text-center text-red-600">{error}</div>}
          {!loading && !error && (
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <select
                name="lawyer_id"
                value={form.lawyer_id}
                onChange={handleChange}
                required
                className="border rounded px-2 py-1"
              >
                <option value="">Select Lawyer</option>
                {lawyers.map((lawyer) => (
                  <option key={lawyer.id} value={lawyer.id}>
                    {lawyer.name} ({lawyer.email})
                  </option>
                ))}
              </select>
              <input
                type="text"
                name="title"
                value={form.title}
                onChange={handleChange}
                placeholder="Title"
                className="border rounded px-2 py-1"
                required
              />
              <input
                type="file"
                name="documents"
                multiple
                onChange={handleFileChange}
                className="border rounded px-2 py-1"
              />
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder="Message"
                className="border rounded px-2 py-1"
              />
              <button
                type="submit"
                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-800"
              >
                Send Request
              </button>
              {formError && <div className="text-red-600">{formError}</div>}
              {success && <div className="text-green-600">{success}</div>}
            </form>
          )}
        </div>
      )}
    </div>
  );
}
